import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { Brands } from '../../common/constants';
import ExternalLinkSVG from '../../themes/wls/icons/external-link';

const Container = styled.div.attrs({ className: 'ui__list-link-item' })`
  ${(props) => `
    padding: ${props.theme.borders.box ? props.theme.whitespace.small : 0} 0 0 0;
    border: ${props.theme.borders.box};
    margin-bottom: ${props.theme.whitespace.gutter};
    border-bottom: 1px solid ${props.theme.colours.border}!important;
  `} box-sizing: border-box;
  background: white;
  margin-bottom: 5px;
  margin-top: -10px;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: ${(props) =>
    props.border ? `1px solid ${props.theme.colours.border}` : 0};
  align-items: center;
  padding: 0 15px 10px 15px;
  `;

const Label = styled.label`
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;


const PrimaryText = styled.h3`
  ${(props) => props.theme.type.h3};
  flex: 1;
  margin-top: 0;
`;

const SecondaryText = styled.div`
  padding: 0 15px 10px 15px;
  ${(props) => props.brand === Brands.Wireless && props.theme.type.descriptionXs}
  @media (min-width: 480px) {
    ${(props) => props.brand === Brands.Wireless && props.theme.type.descriptionSm}
  }
`;

const StyledLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: ${(props) => props.brand === Brands.Wireless ? '44px 15px 20px' : '20px 15px'};
  color: ${props => props.theme.colours.blue} !important;
  font-size: 16px;
  text-decoration: none;
  gap: 8px;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledExternalLink = styled(ExternalLinkSVG)`
  width: 16px;
  height: 16px;
  fill: ${props => props.theme.colours.blue};
`;

const ListLinkItem = ({ primary, secondary, brand, url, urlText, className }) => (
  <Container className={`listLinkItem ${className}`}>
    <Wrap className="listLinkItem-wrap" border={!!secondary}>
      <Label>
        <PrimaryText>{primary}</PrimaryText>
      </Label>
    </Wrap>
    {secondary.length > 0 && <SecondaryText brand={brand} className="list-link-item-secondary">{parse(secondary)}</SecondaryText>}
    <StyledLink href={url} brand={brand} target="_blank">
      {parse(urlText)}
      <StyledExternalLink />
    </StyledLink>
  </Container>
);

ListLinkItem.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  url: PropTypes.string.isRequired,
  urlText: PropTypes.string.isRequired,
  className: PropTypes.string,
  brand: PropTypes.string.isRequired
};

ListLinkItem.defaultProps = {
  secondary: '',
  className: ''
};

export default ListLinkItem;
